import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";

import CustomPopupForm from "../../../../component/customPopupModel";
import ChatComponent from "../../../../component/chatComponent";

function CustomerChat({ order_id, onClose,customer_name,customer_img,orderId }) {
  const showSnackbar = useSnackbar();
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchOrdersChat();
    const interval = setInterval(() => {
      fetchOrdersChat();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchOrdersChat = () => {
    axiosInstance
      .get(`/customer/chat/messages?orderId=${order_id}`, { skipLoader: true })
      .then((res) => {
        const mapped =
          res?.data
            ?.map((msg) => ({
              sender: msg?.senderRole === "store" ? "sender" : "receiver",
              text: msg?.message,
              relatedMismatch: msg?.relatedMismatch,
              time: new Date(msg?.createdAt).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
            }))
            .reverse() || [];
        setMessages(mapped);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  const addMessage = (chatMessage) => {
    const now = new Date();
    const newMsg = {
      sender: "sender",
      text: chatMessage,
      time: now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    setMessages((prev) => [...prev, newMsg]);

    let payload = {
      orderId: Number(order_id),
      senderRole: "store",
      messageType: "text",
      message: chatMessage,
    };
    axiosInstance
      .post(`/customer/chat/message`, payload, { skipLoader: true })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <ChatComponent
      title={`${customer_name}`}
      onClose={onClose}
      messages={messages}
      onSend={addMessage}
      customer_img={customer_img}
      orderId={orderId}
    />
  );
}

export default CustomerChat;
